import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-author-profile-section',
  templateUrl: './author-profile-section.component.html',
  styleUrls: ['./author-profile-section.component.scss']
})
export class AuthorProfileSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
